export default __webpack_public_path__ + "static/media/Group 3239.bc2d6a56.svg";